// extracted by mini-css-extract-plugin
module.exports = {"editorArea":"RepositoryConfigInitializer--editorArea"};